import React from "react";
import { GlobalProvider } from "./src/contexts/global-provider";
import { SearchProvider } from "./src/contexts/search-provider";
import "./src/styles/main.scss";

export const wrapRootElement = ({ element }: any) => (
  <GlobalProvider>
    <SearchProvider>{element}</SearchProvider>
  </GlobalProvider>
);
